import {get} from "lodash"

import isContentKey from "./helpers/isContentKey"

export type formatErrorCallback = (code: string) => string

export const getErrorMessage = (err: RawGraphError | GraphError | PBError | any): string => {
  let msg = "There was some sort of error"
  const dataMsg = get(err, "response.data.message", null)
  const graphErrorMsg = get(err, "networkError.message", null)
  const errorMsg = get(err, "message", null)

  if (isContentKey(graphErrorMsg)) {
    msg = graphErrorMsg
  } else if (isContentKey(errorMsg)) {
    msg = errorMsg
  } else if (dataMsg) {
    msg = dataMsg
  }

  return msg
}

export const getErrorValues = (err: RawGraphError | GraphError | PBError | any): {[key: string]: any} => {
  let data = err?.data || {}
  const graphErrorData = get(err, "networkError.errorData", null)
  const errorData = get(err, "errorData", null)

  if (graphErrorData) {
    data = graphErrorData
  } else if (errorData) {
    data = errorData
  }

  return data
}
